// @flow
import axios from 'lib/defaultClient';

export type WriteCommentPayload = {
  partnerId: string,
  text: string,
  replyTo?: ?string,
};

export const writeComment = ({ partnerId, text, replyTo }: WriteCommentPayload) =>
  axios.post(`/partners/${partnerId}/comments`, {
    text,
    reply_to: replyTo,
  });

export type ReadCommentsPayload = {
  partnerId: string,
};

export const readComments = ({ partnerId }: ReadCommentsPayload) =>
  axios.get(`/partners/${partnerId}/comments`);

export type ReadSubCommentsPayload = {
  partnerId: string,
  commentId: string,
  parentId?: ?string,
};

export const readSubComments = ({ partnerId, commentId }: ReadSubCommentsPayload) =>
  axios.get(`/partners/${partnerId}/comments/${commentId}/replies`);

export type RemoveCommentPayload = {
  partnerId: string,
  commentId: string,
};

export const removeComment = ({ partnerId, commentId }: RemoveCommentPayload) => {
  return axios.delete(`/partners/${partnerId}/comments/${commentId}`);
};

export type EditCommentPayload = {
  partnerId: string,
  commentId: string,
  text: string,
  parentId: ?string,
};

export const editComment = ({ partnerId, commentId, text }: EditCommentPayload) =>
  axios.patch(`/partners/${partnerId}/comments/${commentId}`, { text });



// WEBPACK FOOTER //
// ./src/lib/api/partners/comments.js